import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { ApiService, OutletService } from '../api';
import { GlobalsService } from '../globals/globals.service';

@Injectable({
    providedIn: 'root',
})
export class CityService extends ApiService {
    constructor(protected http: HttpClient, private outletService: OutletService, private globals: GlobalsService) {
        super(http);
    }

    getCities(name: string) {
        return this.post(this.generalUrl, `general/hrc/outlets/cities?query=${name}`);
    }

    getPlaceImage(city) {
        const defaultUrl = `${environment.outletPortalUrl}/assets/images/city-placeholder.svg`;

        return new Observable((observer) => {
            const element = document.createElement('div');
            let map: google.maps.Map;
            let mapService: google.maps.places.PlacesService;

            map = new google.maps.Map(element);
            mapService = new google.maps.places.PlacesService(map);

            const request = {
                query: city,
                fields: ['photos'],
            };
            try {
                mapService.findPlaceFromQuery(
                    request,
                    (
                        results: google.maps.places.PlaceResult[] | null,
                        status: google.maps.places.PlacesServiceStatus,
                    ) => {
                        if (status === google.maps.places.PlacesServiceStatus.OK && results) {
                            const url = results[0]?.photos
                                ? results[0].photos[0].getUrl({ maxHeight: 200 })
                                : defaultUrl;
                            observer.next(url);
                        }
                    },
                );
            } catch (e) {
                console.log(e);
            }
        });
    }
}
